<template>
  <div class="container">
    <div class="subheader">
      About
    </div>
    <div
      class="about-the-team"
    >Based in Toronto, Ontario, Overlook studios is an independent video game studio that focuses on exploring new, fun ideas. We as a team "overlook" the projects we build at every stage of development to ensure we're sticking to what we believe in.
    What started off in university with a goal to create a game over christmas break, grew to 4 best friends living together and doing what they love. While the team may no longer be physically together, our fire to build will never truly burn out.</div>
    <div class="team-container">
      <div class="member-row">
        <div class="pic">
          <img src="@/assets/studio-page/michael.png" class="michael" alt="michael-programmer"/>
        </div>
        <div class="description">
          <div class="title">
            <!-- <a href="https://michaelbitzos.com/devblog/introductions" target="_blank">Michael</a> - <span class="subtitle">Lead Programmer</span></div> -->
            Michael <span class="subtitle">- Lead Programmer</span> <a class="link" href="https://michaelbitzos.com/devblog/introductions" target="_blank">[devblog]</a></div>
            <div class="m-subtitle">Lead Programmer</div>
          <div>An obsessive programmer that finds true satisfaction when building complex game systems. He can be found writing a framework for god-knows-what.</div>
        </div>
      </div>
      <div class="member-row">
        <div class="pic">
          <img src="@/assets/studio-page/ben.png" alt="ben-designer"/>
        </div>
        <div class="description">
          <div class="title">
            Ben <span class="subtitle">- Designer/Programmer</span></div>
            <div class="m-subtitle">Designer/Programmer</div>
          <div>A designer with a dedicated vision that keeps the team on track with a holistic overview of where a project is heading. He can be found deep in focus creating something obscurely awesome.</div>
        </div>
      </div>
      <div class="member-row">
        <div class="pic">
          <img src="@/assets/studio-page/adam.png" alt="adam-artist"/>
        </div>
        <div class="description">
          <div class="title">
            Adam <span class="subtitle">- Artist</span> <a class="link" href="https://pixelgrim.artstation.com/" target="_blank">[artstation]</a></div>
            <div class="m-subtitle">Artist</div>
          <div>A perfectionist pixel artist with the ability to inspire entire game ideas with their concept art alone. He can be found at 4am in the dark crafting something beautifully cursed.</div>
        </div>
      </div>
      <div class="member-row">
        <div class="pic">
          <img src="@/assets/studio-page/cole.png" class="cole" alt="cole-music-sfx"/>
        </div>
        <div class="description">
          <div class="title">
            Cole <span class="subtitle">- Music/SFX</span></div>
            <div class="m-subtitle">Music/SFX</div>
          <div>A musician that aims to energize when asked, or chill to the bone when needed. He can also be found screaming in his room making sound effects.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.container {
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
}
a {
  color: inherit;
  opacity: 0.75;

  &:hover {
    opacity: 1;
  }
}

.team-container {
  width: 100%;
}
.subheader {
  font-size: 35px;
  margin-bottom: 30px;
  &:not(:first-child) {
    margin-top: 30px;
  }
  border-bottom: 2px solid white;
  width: 100%;
  text-align:center;
  padding-bottom:30px;
}

.about-the-team {
  border-bottom: 2px solid white;
  padding-bottom:30px;
  margin-bottom: 30px;
}

.member-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 30px;

  .pic {
    $img-size: 85px;
    width: $img-size;
    height: $img-size;
    overflow: hidden;
    flex-shrink:0;
    border-radius: 50%;
    border: 2px solid white;
    margin-right: 20px;
    text-align: center;

    img {
      object-fit: cover;
      image-rendering: pixelated;
      width: 70%;
      &.michael {
        width: 80%;
        margin-top: 2px;
      }
      &.cole {
        width: 100%;
      }
    }
  }
  .description {
    text-align: left;
    font-size: 15px;


    .title {
      font-size: 25px;
      margin-bottom:5px;
      display: flex;
      align-items: center;

      .link {
        font-size: 15px;
        margin-left: 10px;
      }
      .subtitle {
        font-size: 20px;
        margin-left: 5px;
      }
    }

  }
}
.m-subtitle {
  display: none;
  font-size: 15px;
  font-weight: bold;;
}
@media only screen and (max-width: 900px) {
  .container {
    width: 90%;
  }

  .subtitle {
    font-size: 15px;
    font-weight: bold;
  }
}
@media only screen and (max-width: 600px) {
  .title {
    margin-bottom: 5px;
  }
  .m-subtitle {
    display: block;
    margin-bottom: 5px;
  }
  .subtitle {
    display: none;
  }
}
</style>